import {
  CustomRulesOutput,
  UpdateCustomRuleInput,
  UpdateCustomRuleOutput,
} from '@allocab/allocab-passenger-shared-types';
import { useMutation } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient } from '../services/datastore/react-query';
import { passengerApi } from '../services/network/Api';
import { APIError } from '../services/network/types';

type Input = UpdateCustomRuleInput & { receptionistToDelete?: string; receptionistToUpdate?: string };

const updateInvoiceMention = ({ receptionistToDelete: _, receptionistToUpdate: __, ...input }: Input) =>
  passengerApi.put<UpdateCustomRuleInput, UpdateCustomRuleOutput>('/account/v1/custom-rules/INVOICE_MENTION', input);

export const useUpdateInvoiceMention = () => {
  const updateInvoiceMentionMutation = useMutation<UpdateCustomRuleOutput, APIError, Input, Input>({
    mutationFn: updateInvoiceMention,
    onMutate: input => input,
    onSuccess: data => {
      queryClient.setQueryData<CustomRulesOutput>(queryKeys.user.fetchCustomRules(), oldData =>
        oldData ? { ...oldData, invoiceMention: data } : oldData,
      );
    },
  });

  return updateInvoiceMentionMutation;
};
